import { useNavigate } from 'react-router';
import { trackEvent } from './analytics';
import { SegmentObj, Target } from './types/LinkTypes.interface';

export const goToExternal = (url: string, segmentObj?: SegmentObj, target?: Target) => {
  if (segmentObj) {
    trackEvent(`${segmentObj.title} Button is clicked`, {
      referrer: window.location.pathname,
      url: url,
      ...segmentObj,
    });
  }

  const targetToUse = !!target ? target : Target.blank;

  window.open(url, targetToUse);
};

export const useNavigateWithSegment = () => {
  const navigate = useNavigate();
  return (url: string, segmentObj?: SegmentObj) => {
    if (segmentObj) {
      trackEvent(`${segmentObj.title} Button is clicked`, {
        referrer: window.location.pathname,
        url: url,
        ...segmentObj,
      });
    }

    navigate(url);
  };
};
